export const getRequiredBillingPermission = ({ id: billingTypeUri = '' }) => {
  switch (billingTypeUri) {
    case 'urn:replicon:billing-type:time-and-material':
      return 'urn:replicon:project-action:view-billing-rates';

    case 'urn:replicon:billing-type:fixed-bid':
      return 'urn:replicon:project-action:view-billing-data';

    case 'urn:replicon:billing-type:billing-contract':
      return 'urn:replicon:project-action:view-billing-contracts';

    default:
      return '';
  }
};

export const permissionsMap = {
  canEditProject: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-project'),
  canViewBilling: (actionMap, { billingType }) =>
    actionMap.includes(getRequiredBillingPermission(billingType || {})) &&
    actionMap.includes('urn:replicon:project-action:view-billing-data'),
  canEditBilling: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-billing-data'),
  canViewProjectBillingData: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-billing-data'),
  canViewBillingContracts: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-billing-contracts'),
  canEditBillingContracts: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-billing-contracts'),
  canViewProjectEstimates: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-project-estimates'),
  canEditProjectEstimates: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-project-estimates'),
  canViewRevenueContracts: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-revenue-contract'),
  canEditRevenueContracts: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-revenue-contract'),
  canViewProjectCostData: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-cost-data'),
  canEditProjectCostData: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-cost-data'),
  canViewProjectCostRates: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-project-cost-rates'),
  canEditProjectCostRates: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-project-cost-rates'),
  canViewBillingRates: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-billing-rates'),
  canEditBillingRates: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-billing-rates'),
  canViewDocuments: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-documents'),
  canEditDocuments: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-documents'),
  canRecalculateBillingData: actionMap =>
    actionMap.includes('urn:replicon:project-action:recalculate-billing-item'),
  canViewTasks: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-tasks'),
  canEditTasks: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-tasks'),
  canViewTeam: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-team'),
  canViewCostTypes: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-cost-type'),
  canEditCostTypes: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-cost-type'),
  canViewExpenseCodes: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-expense-codes'),
  canEditExpenseCodes: actionMap =>
    actionMap.includes('urn:replicon:project-action:edit-expense-codes'),
  canViewPortfolio: actionMap =>
    actionMap.includes('urn:replicon:project-action:view-portfolio')
};

export const useProjectInfoPermissions = ({
  permittedActionUris,
  billingType
}) => {
  const projectPermissions = {};

  Object.keys(permissionsMap).forEach(key => {
    projectPermissions[key] = permissionsMap[key](permittedActionUris || [], {
      billingType
    });
  });

  return projectPermissions;
};

export default useProjectInfoPermissions;
